import { useApplyWithSeek } from "../hooks/use_apply_with_seek";
import ApplyWithSeekIcon from "~/components/icons/apply_with_seek.svg";

export const ApplyWithSeekButton = () => {
  const { applyWithSeekEnabled } = useApplyWithSeek();

  if (!applyWithSeekEnabled) {
    return null;
  }

  const handleApplyWithSeekClick = () => {
    // TODO: Implement apply with Seek functionality
  };

  return (
    <button onClick={handleApplyWithSeekClick}>
      <img src={ApplyWithSeekIcon} alt="Apply with Seek" />
    </button>
  );
};

export default ApplyWithSeekButton;
